import { OperationVariables, ApolloQueryResult } from '@apollo/client'
import { ButtonBase, IconButton, Typography } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import React, { useState } from 'react'

import EditCreditorModal from '../../components/EditCreditorModal'
import { addCommaToPrice } from '../../helpers/numbers'
import { persianRegex } from '../../helpers/regex'
import { getTranslate } from '../../localization'
import { Wallet } from '../../types/wallet'
import { CreditorListItem } from '../../types/walletCreditor'
import useStyles from './styles/creditorTableRow.styles'

interface CreditorTableRowDesktopProps {
  data: CreditorListItem
  wallet: Wallet
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      creditors: CreditorListItem[]
    }>
  >
}

export const CreditorTableRowDesktop: React.FC<
  CreditorTableRowDesktopProps
> = ({ data, wallet, refetch }) => {
  const classes = useStyles()
  const [isEditCreditorOpen, setIsEditCreditorOpen] = useState<boolean>(false)

  const isPersianSenderWallet =
    data.entity.entityName && persianRegex.test(data.entity.entityName)

  return (
    <div className={[classes.tableRowRoot].join(' ')}>
      <ButtonBase className={classes.tableRow}>
        <div
          className={classes.nameCell}
          style={
            isPersianSenderWallet ? { fontFamily: 'IranSans' } : undefined
          }>
          <Typography variant="h4">{data.entity.entityName}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {addCommaToPrice(data.walletBalance)}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {addCommaToPrice(data.remainingCreditBalance)}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {addCommaToPrice(data.remainingReservable)}
          </Typography>
        </div>
        {data.active ? (
          <div>
            <Typography variant="body1" className={classes.active}>
              {getTranslate('Active')}
            </Typography>
          </div>
        ) : (
          <div>
            <Typography variant="body1" className={classes.deactive}>
              {getTranslate('Deactive')}
            </Typography>
          </div>
        )}
        <IconButton
          className={classes.editIcon}
          onClick={() => {
            setIsEditCreditorOpen(true)
          }}>
          <EditIcon />
        </IconButton>
      </ButtonBase>
      {isEditCreditorOpen && (
        <EditCreditorModal
          creditorID={data.creditorID}
          currency={wallet.currency}
          isOpen={isEditCreditorOpen}
          setIsOpen={setIsEditCreditorOpen}
          refetch={refetch}
        />
      )}
    </div>
  )
}
